var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagMaldives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.56519 8.3479H26.4347V23.6523H5.56519V8.3479Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5767 20.5218C16.0794 20.5218 14.0549 18.4973 14.0549 16.0001C14.0549 13.5028 16.0794 11.4783 18.5767 11.4783C19.3553 11.4783 20.088 11.6752 20.7276 12.0218C19.7242 11.0405 18.352 10.4348 16.8376 10.4348C13.7641 10.4348 11.2724 12.9264 11.2724 16C11.2724 19.0736 13.7641 21.5652 16.8376 21.5652C18.352 21.5652 19.7242 20.9595 20.7276 19.9782C20.088 20.3249 19.3553 20.5218 18.5767 20.5218Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMaldives);
export default __webpack_public_path__ + "static/media/flag_maldives.b3728fd9dc36c8361faba4f2204d8abb.svg";
export { ForwardRef as ReactComponent };